import {
  IconButton,
  Popover,
  Box,
  Container,
  Stack,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Typography } from "@mui/material";
import {
  Close,
  MapOutlined,
} from "@mui/icons-material";
import React, {memo, useEffect} from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useCanLockedInspection} from "../../../../_helpers";
import BottomDrawer from "../../components/BottomDrawer";
import { alpha } from "@mui/material/styles";
import { apps, userAccountTypeConstants } from "../../../../_constants";
import Hidden from "../../../../components/Hidden";
import SecondSignatureRepairRequest from "./SecondSignatureRepairRequest";

const  RepairRequests = ({
  setOpenRepairRequestMap,
  selectedInspection,
  bottomDrawer,
  bottomDrawerClose,
  loading,
  title,
  keyPath,
  buttonText,
  assignmentDetail,
  wbObjectId,
  data,
  ...props
}) =>  {
  const history = useHistory();
  const { t , } = useTranslation();
  const [requests, setRequests] = useState([]);
  const [readOnly, setReadOnly] = useState(false);
  const classes = useStyles({ readOnly });
  const [openTooltip, setOpenTooltip] = useState({ element: null, image: "" });
  const app = useSelector((state) => state.app);
  const { user } = useSelector((state) => state.authentication);
  const { drawingFiles } = useSelector((state) => state.dossier);
  const { selected } = useSelector((state) => state.buildings);
  const { isCompleteRRLoading, isUpdateReworkLoading, deleteRRLoading } =
    useSelector((state) => state.surveying);
  const [selectedRequestId, setSelectedRequestId] = useState(null);
  const [rowsSelected, setRowsSelected] = useState({ data: [], list: [] });
  const canLockedInspection = useCanLockedInspection();
 
  useEffect(() => {
    if (selectedRequestId && !deleteRRLoading) {
      setSelectedRequestId(null);
    }
  }, [selectedRequestId, deleteRRLoading]);

  useEffect(() => {
    if (selectedInspection) {
      setReadOnly(
        selectedInspection.secondSignatureDate ||
          canLockedInspection ||
          !selectedInspection.hasRights
      );
    }
  }, [selectedInspection && selectedInspection.status, canLockedInspection]);

  useEffect(() => {
    if (data) {
      setRequests(
        data.map((request) => {
          request.textResolvers = [];
          if (request.resolvers && request.resolvers.length)
            request.textResolvers = request.resolvers.map((x) => x.name).join(', ');

          return {
            ...request,
            id: request.requestId 
          };
        })
      );
      setRowsSelected((p) => {
       return {
         ...p,
         data: p.data.map((a) =>
           data.find((c) => c.requestId === a.requestId)
         ),
       };
     });
   }
  }, [data, isCompleteRRLoading, isUpdateReworkLoading, deleteRRLoading]);

  useEffect(() => {
    if (data) {
      setRequests(
        data.map((request) => {
          request.textResolvers = [];
          if (request.resolvers && request.resolvers.length)
            request.textResolvers = request.resolvers.map((x) => x.name).join(', ');

          return {
            ...request,
            id: request.requestId 
          };
        })
      );
      setRowsSelected((p) => {
       return {
         ...p,
         data: p.data.map((a) =>
           data.find((c) => c.requestId === a.requestId)
         ),
       };
     });
   }
  }, [data, isCompleteRRLoading, isUpdateReworkLoading, deleteRRLoading]);

 

  const handleTooltipClose = (event) => {
    event.stopPropagation();
    setOpenTooltip({ element: null, image: null });
  };

 

 
  const redirectToMap = () => {
    history.push({
      pathname:
        user.type !== userAccountTypeConstants.buyer && app !== apps.aftercare
          ? `/werk/${selected.projectNo}/${
              app === 3 ? "kwaliteitsborging/meldingen/map" : "meldingen/map"
            }`
          : `/meldingen/map`,
      state: {
        selectedRequest: null,
        buildingId: selectedInspection && selectedInspection.buildingId,
        requests: requests,
      },
    });
  };


  const canShowMapIcon =
    requests && requests.length && requests.some((p) => p.drawingPinLocation);

  return (<>
    <Hidden smUp>
      <BottomDrawer
        open={bottomDrawer.open && bottomDrawer.key === "gebrekenlijst"}
        close={bottomDrawerClose}
      >
        <Container maxWidth={false} className={classes.mainContainer}>
        <Box display="flex" flexDirection="column" sx={{ height: "100%" }}>
          <Stack direction={'row'} justifyContent={'space-between'} px={1} alignItems={'center'}>
        <Box p={1} display={'flex'} alignItems={'center'} >
        <Typography variant="h6" >{t(title)}</Typography>
        {!!canShowMapIcon &&
          drawingFiles &&
          !!drawingFiles.length && (
            <IconButton
             color="primary"
              aria-label="upload picture"
              component="span"
              onClick={() => redirectToMap()}
            >
              <MapOutlined className={classes.mapIcon} />
            </IconButton>
          )}
      </Box>
      <Box>
        <Close
        className={classes.drawerIcon}
        onClick={bottomDrawerClose}
        />
      </Box>
      </Stack>
      <Box sx={{flex:1}}>
            <SecondSignatureRepairRequest
              requests={requests}
              loading={loading}
              selectedInspection={selectedInspection}
            />
            </Box>
            </Box>
      </Container>
      </BottomDrawer>
    </Hidden>
    <Hidden smDown>
      <Container maxWidth={false} className={classes.mainContainer}>
      <Box display="flex" flexDirection="column" sx={{ height: "100%" }}>
      <Box bgcolor={'white'} p={1} display={'flex'} alignItems={'center'} >
        <Typography variant="h6" >{t(title)}</Typography>
        {!!canShowMapIcon &&
          drawingFiles &&
          !!drawingFiles.length && (
            <IconButton
             color="primary"
              aria-label="upload picture"
              component="span"
              onClick={() => redirectToMap()}
            >
              <MapOutlined className={classes.mapIcon} />
            </IconButton>
          )}
      </Box>
      <Box sx={{flex:1}}>
        <SecondSignatureRepairRequest
          requests={requests}
          loading={loading}
          selectedInspection={selectedInspection}
        />
        </Box>
      </Box>
      </Container>
    </Hidden>
    <Popover
      open={openTooltip.element && openTooltip.image}
      anchorEl={openTooltip.element}
      onClose={handleTooltipClose}
      anchorOrigin={{
        vertical: "center",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "center",
        horizontal: "left",
      }}
    >
      <div className={classes.tooltipImageContainer}>
        <img src={openTooltip.image} alt="" />
      </div>
    </Popover>
   
  </>);
}
export default memo(RepairRequests)
const useStyles = makeStyles((theme) => ({
  "@global": {
    ".MuiButtonBase-root:focus": {
      outline: 0,
    },
  },
  customCheckbox: {
    [theme.breakpoints.down("md")]: {
      "& .MuiSvgIcon-root": {
        height: 14,
      },
    },
  },
  drawerHeader: {
    display: "flex",
    padding: theme.spacing(1),
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: 7,
  },
  surveyMomentCardTitle: {
    fontSize: 12,
    fontWeight: "bold",
    color: theme.palette.common.black,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  drawerIcon: {
    fill: theme.palette.grey[300],
    cursor: "pointer",
  },
  stickyHeader: {
    position: "sticky",
    top: 0,
    background: theme.palette.common.white,
    zIndex: 101,
  },
  cardTitle: {
    fontSize: 12,
    color: theme.palette.grey[500],
    whiteSpace: "wrap",
  },
   mainContainer: {
   height: "100%",
    width: "100%",
    overflow: "auto",
    padding: 0,
    },
  customCell: {
    position: "relative",
  },
  cardSubTitle: {
    fontSize: 12,
    fontWeight: "bold",
    color: theme.palette.common.black,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    marginBottom: 4,
  },
  mapIcon: {
    fill: theme.palette.primary.main,
    fontSize: 18,
  },
  tooltipImageContainer: {
    padding: theme.spacing(1.25),
    "& > img": {
      maxWidth: "200px",
      maxHeight: "200px",
    },
  },
  colorSuccess: {
    padding: theme.spacing(0.2),
    color: theme.palette.success.main,
  },
  success: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
    "&:hover": {
      backgroundColor: `${alpha(theme.palette.success.main, 0.7)} !important`,
    },
  },
  menuRootContainer: {
    zIndex: theme.zIndex.modal,
  },
  content: {
    position: "absolute",
    maxWidth: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  spacer: {
    height: 0,
    overflow: "hidden",
  },
}));

